import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    loginDialogWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '30px',
        alignSelf: 'stretch',
        [theme.breakpoints.up('lg')]: {
            width: '642px',
            padding: '60px 40px 40px 40px',
            gap: '30px',
        },
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            borderColor: theme.palette.secondary.dark,
            backgroundColor: theme.palette.common.white,
        }),
    }),
    loginFormWrapper: css({
        width: '100%',
        paddingTop: '10px',
    }),
    loginButton: css({
        marginTop: '30px',
        width: isHosTheme ? '185px' : '100%',
        borderRadius: '100px',
        padding: '16px 16px 12px 16px',
    }),
    loginDialogCloseButton: css({
        position: 'absolute',
        top: '20px',
        right: '20px',
        [theme.breakpoints.up('lg')]: {
            top: '25px',
            right: '25px',
        },
    }),
    forgottenPassword: css({
        padding: 0,
        marginTop: '20px',
        ...(isHosTheme && {
            '&:hover': {
                background: 'transparent',
            },
        }),
    }),
    forgottenPasswordText: css({
        color: theme.palette.text.secondary,
        textDecoration: 'underline',
        textTransform: 'none',
        ...(isHosTheme && {
            letterSpacing: '0.24px',
            color: theme.palette.text.primary,
            '&:hover': {
                color: theme.palette.primary.light,
            },
        }),
    }),
    loginDialogInput: css({
        '.MuiInput-input': {
            paddingTop: '10px',
            paddingBottom: '10px',
            fontSize: '16px',
        },
    }),
    loginDialogErrorBox: css({
        display: 'flex',
        padding: isHosTheme ? '16px' : '20px',
        alignItems: isHosTheme ? 'flex-start' : 'flex-end',
        gap: isHosTheme ? '20px' : '10px',
        alignSelf: 'stretch',
        background: theme.palette.error.light,
        color: theme.palette.primary.main,
        marginBottom: '20px',

        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            border: `1px solid ${theme.palette.error.main}`,
        }),
    }),
};
